// extracted by mini-css-extract-plugin
export default {"container":"BarcodeResults_container__Binry","loadingCard":"BarcodeResults_loadingCard__TpQz7","empty":"BarcodeResults_empty__l8KSy"};